import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as Joi from 'joi';

interface EditDeleteReturn {
  /**
   * Form to send edit & delete
   */
  form: UseFormReturn<any>;
}

/**
 * A hook to handle search functionality
 * @returns
 */
export const usePaymentReportDateFunction = (): EditDeleteReturn => {
  const form = useForm({
    mode: 'onSubmit',
    resolver: joiResolver(schema),
  });

  return {
    form,
  };
};

const schema = Joi.object({
  startDate: Joi.string().required().messages({
    'date.base': 'Payment Start Date not allowed to be empty.',
    'date.max': 'Payment Start Date should not be greater than current date.',
    'any.required': 'Payment Start Date not allowed to be empty.',
  }),
  endDate: Joi.string().required().messages({
    'date.base': 'Payment End Date not allowed to be empty.',
    'date.max': 'Payment End Date should not be greater than current date.',
    'any.required': 'Payment End Date not allowed to be empty.',
  }),
});
